export default __webpack_public_path__ + "static/media/failed_to_load.17dda2ed.svg";